import React from 'react'
import { Button, Result, Table, Tag } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { useFetchQuestionsQuery } from '../../../../../store/apis/question.api'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { questionActions } from '../../../../../store/slices/question.slice'
import { useVersionId } from '../../../../../utils/parseURL.helper'
import { truncate } from 'lodash'
import QuestionDefinitionActions from '../question-definition/QuestionDefinitionActions'
import { getQuestionTypeLabel } from '../drawer/QuestionForm'

const QuestionsTable = () => {
    const dispatch = useDispatch()
    const { token } = useParams()
    const versionId = useVersionId()

    const { data: questions, isFetching, error, refetch } = useFetchQuestionsQuery({ token, versionId })


    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (name, question) => (
                <a type='link' onClick={() => dispatch(questionActions.setEditingQuestionId(question.key))} data-test="question-link">
                    {truncate(name, { length: 96 })}
                </a>
            ),
        },
        {
            title: 'Type',
            dataIndex: 'questionType',
            key: 'questionType',
            width: 120,
            render: type => type && <Tag>{getQuestionTypeLabel(type)}</Tag>,
        },
        {
            title: 'Rubrics',
            dataIndex: 'questionRubrics',
            key: 'questionRubrics',
            width: 80,
        },
        {
            title: 'Action',
            key: 'action',
            width: '8%',
            render: question => (
                <div className='d-flex'>
                    <QuestionDefinitionActions question={question} />
                    <Button
                        shape='circle'
                        type='text'
                        aria-label='Edit'
                        title='Edit'
                        onClick={() => dispatch(questionActions.setEditingQuestionId(question.key))}
                    >
                        <EditOutlined className='primary-color' />
                    </Button>
                </div>
            ),
        },
    ]

    const data = questions?.map(question => {
        return {
            key: question.id,
            name: question.name || question.content,
            questionType: question.questionType,
            questionRubrics: question.questionRubrics?.length,
        }
    })

    return error ? (
        <Result
            status='error'
            title='Questions Fetch Failed'
            subTitle={error}
            extra={[
                <Button key='try' onClick={() => refetch()} loading={isFetching}>
                    Try Again
                </Button>,
            ]}
        />
    ) : (
        <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            data-test="questions-table"
            loading={{ spinning: isFetching, tip: 'Loading questions...' }}
        />
    )
}

export default QuestionsTable
